import { ContactDetailsResponse } from '../../types'

export interface ContactCompaniesProps {
  data: ContactDetailsResponse
  invalidate: () => void
}
